// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__QBtt9","title":"Info_title___-WXF","links":"Info_links__Ev70_","link":"Info_link__V6YeT","logo":"Info_logo__3FXpi"};